import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function scrollerSponsors() {
  const $sponsorWrapper = $('.scrollerSponsors-wrapper');
  const widgetName = 'scrollerSponsors';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof scrollerSponsorsOpts === 'undefined' ? null : scrollerSponsorsOpts;

  if (!widgetOpts) {
    $sponsorWrapper.remove();
    missingWidget(widgetName);
    return;
  }

  function restructureSponsors() {
    setTimeout(() => {
      changeSponsorsStructure();
      $sponsorWrapper.css('opacity', '1');
    }, 3000);
  }

  if ($('body').hasClass('pageIsLoaded')) {
    restructureSponsors();
  } else {
    const pageLoadedObserver = new MutationObserver(function () {
      if ($('body').hasClass('pageIsLoaded')) {
        pageLoadedObserver.disconnect();
        restructureSponsors();
      }
    });
    pageLoadedObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function changeSponsorsStructure() {
    const $majorSponsorTitle = $('#scrollerSponsors #majorSponsorTitleContainer');
    const $majorSponsorContainer = $('#scrollerSponsors .majorSponsor');
    const majorSponsorsTitle = $('#majorSponsorTitleContainer .homepageh1').text();

    if ($majorSponsorContainer.length && $majorSponsorTitle.length) {
      $majorSponsorTitle.wrapAll('<div class="major-sponsor-wrapper" id="major-sponsor-wrapper">');
      $majorSponsorContainer.appendTo($('#major-sponsor-wrapper'));
      $('#major-sponsor-wrapper').prependTo($('#scrollerSponsors'));

      $('#majorSponsorTitleContainer .homepageh1').replaceWith(
        `<h4 class="major-sponsor-title">${majorSponsorsTitle}</h4>`,
      );
    }

    const sponsorsTitleContent = $('#sponsorsTitleContainer .homepageh1').text();
    $('#sponsorsTitleContainer .homepageh1').replaceWith(
      `<h4 class="main-sponsors-title">${sponsorsTitleContent}</h4>`,
    );

    $('#scrollerSponsors').append('<div class="scroller-container">');
    $('#scrollerSponsors .sponsorWidgetContainer ').appendTo('.scroller-container');
    $('#scrollerSponsors #sponsorArrowLeft').appendTo('.scroller-container');
    $('#scrollerSponsors #sponsorArrowRight').appendTo('.scroller-container');

    $('.sponsorCarouselImageContainer a').each(function () {
      const $element = $(this);
      const href = $element.attr('href')?.trim();
      const altText = $element.find('img').attr('alt');
      const url = href?.startsWith('http') ? href : null;
      updateLinksAttributes(url, altText, $element);
    });
  }

  return saffire.widgets.sponsors($widget, {
    scriptPath: widgetOpts.scriptPath,
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    timePerSponsor: 6,
    bw: false,
    rotate: true,
  });
}
